import { Card, Text } from '@leroy-merlin-br/backyard-react'

import { AppStoreBadge, GooglePlayBadge } from './'
import * as S from './styled'

const LINK_APP_STORE =
  'https://apps.apple.com/br/app/leroy-merlin-oferta-e-decor/id1470425305'
const LINK_GOOGLE_PLAY =
  'https://play.google.com/store/apps/details?id=br.com.leroymerlin&hl=pt'

const DownloadAppsCard = () => (
  <Card target="card" shadow="triple">
    <S.Wrapper>
      <Text size="mega" color="n900" isBold noMargin>
        Agora é só baixar nosso app e acompanhar seu pedido em tempo real
      </Text>

      <S.Badges>
        <a
          href={LINK_APP_STORE}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Baixar na App Store">
          <AppStoreBadge />
        </a>
        <a
          href={LINK_GOOGLE_PLAY}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Baixar no Google Play">
          <GooglePlayBadge />
        </a>
      </S.Badges>
    </S.Wrapper>
  </Card>
)

export default DownloadAppsCard
